import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Why Us',
    href: '#why-us'
  }, {
    name: 'Compliance',
    href: '#compliance'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-white/95 backdrop-blur-sm py-5'}`} data-id="element-245">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-246">
        <div className="flex justify-between items-center" data-id="element-247">
          {/* Logo */}
          <a href="#" className="flex items-center group" aria-label="Compass Recovery Group home" data-id="element-248">
            <img src="https://cdn.magicpatterns.com/uploads/miiyVjkag3qKFYCybFaUjL/pasted-image.jpg" alt="Compass Recovery Group, LLC" className="h-12 md:h-14 w-auto object-contain" data-id="element-249" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-250">
            <ul className="flex items-center gap-6" data-id="element-251">
              {navLinks.map(link => <li key={link.name} data-id="element-252">
                  <a href={link.href} className="text-sm font-medium text-brand-dark hover:text-brand-red transition-colors" data-id="element-253">
                    {link.name}
                  </a>
                </li>)}
            </ul>
            <Link to="/portal" className="bg-brand-red hover:bg-red-800 text-white px-5 py-2.5 rounded text-sm font-semibold transition-colors shadow-sm" data-id="element-254">
              Make a Payment
            </Link>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-brand-dark p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-255">
            {isMobileMenuOpen ? <X size={24} data-id="element-256" /> : <Menu size={24} data-id="element-257" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-xl border-t border-gray-100" data-id="element-258">
          <div className="px-4 pt-2 pb-6 space-y-1 flex flex-col" data-id="element-259">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-brand-dark hover:bg-brand-gray hover:text-brand-red rounded-md" onClick={() => setIsMobileMenuOpen(false)} data-id="element-260">
                {link.name}
              </a>)}
            <div className="pt-4 px-3" data-id="element-261">
              <Link to="/portal" className="block w-full text-center bg-brand-red hover:bg-red-800 text-white px-5 py-3 rounded font-semibold transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-262">
                Make a Payment
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}